import React from 'react';

import { THeadProps } from '@/shared/components/seo/head.types';
import { getResellerBranding } from '@/shared/utils/reseller-branding/reseller-branding';

export const Head: React.FC<THeadProps> = ({
  title = '',
  description = '',
}) => {
  const branding = getResellerBranding();
  const appName = __IS_BACKOFFICE__
    ? branding.backofficeName
    : branding.consoleName;
  const finalTitle = title ? `${title} | ${appName}` : appName;

  return (
    <>
      <title>{finalTitle}</title>
      {description && <meta name="description" content={description} />}
    </>
  );
};
